module.exports = __webpack_public_path__ + "img/img9.adbe99bf.jpg";